export { default as StyleMasterPriceSlot } from './StyleMasterPriceSlot';
